import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ThemeService } from './core/theme/theme.service';
import { Platform } from '@angular/cdk/platform';
import { StorageService } from './core/store/storage/storage.service';
import { environment } from 'src/environments/environment';
import { SubscriptionFacadeService } from './facades/subscription/subscription-facade.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'mvm2';
  constructor(
    private router: Router,
    private themeService: ThemeService,
    private platform: Platform,
    private storageService: StorageService,
    private subscriptionFacade: SubscriptionFacadeService
  ) {
    this.themeService.initializeTheme();
    this.restoreCookieSession();
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.themeService.initializeTheme();
      }
      window.scrollTo(0, 0);
    })
    if (this.platform.IOS) {
      document.body.style.setProperty('-webkit-overflow-scrolling', 'none');
    }
  }
  @HostListener('scroll', ['$event'])
  onScroll(event: Event) {
    // Disable momentum scrolling
    event.preventDefault();
  }

  private restoreCookieSession(): void {
    try {
      const cookieValue = document.cookie.split('; ').find((row) => row.startsWith('myObjectCookie='));
      if (!cookieValue) {
        return;
      }
      const raw = cookieValue.substring(cookieValue.indexOf('=') + 1);
      const myObject = JSON.parse(decodeURIComponent(raw));
      if (!this.storageService.isTokenCurrent(myObject?.token)) {
        this.clearCookie();
        return;
      }
      const retrieveData = this.storageService.getUserData();
      this.storageService.setUserData({
        ...retrieveData,
        "roleId": myObject.roleId,
        "token": myObject.token,
        "isLoggedIn": true,
        "email": myObject.email,
        "authId": myObject.authId,
        "typeId": myObject.typeId,
        "sId": myObject.stylistId
      });
      this.clearCookie();
      this.getFeatureAccess(myObject.stylistId);
    } catch {
      this.clearCookie();
    }
  }

  private clearCookie(): void {
    const pastDate = new Date(0).toUTCString();
    document.cookie = `myObjectCookie=; domain=${environment.domain}; path=/; expires=${pastDate}`;
    document.cookie = `myObjectCookie=; path=/; expires=${pastDate}`;
  }

  getFeatureAccess(id) {
    try {
      let data = {
        stylistId: id,
      };
      this.subscriptionFacade.getFeatureAccess(data).subscribe({
        next: (res: any) => {
          const retrieveData = this.storageService.getUserData();
          this.storageService.setUserData({
            ...retrieveData,
            "isCalendarAccess": res.isCalendarAccess,
            "isDoubleBookingAccess": res.isDoubleBookingAccess,
            "isRecurringAccess": res.isRecurringAccess,
            "isReportsAccess": res.isReportsAccess,
            "isEmailNotification": res.isEmailNotification,
            "isSMSNotification": res.isReportsAccess,
            "locationLimitReached": res.locationLimitReached,
            "notesAccess": res.notesAccess,
            "onlineBookAccess": res.onlineBookAccess,
            "subscriptionExpired": res.subscriptionExpired,
            "gracePeriod": res.gracePeriod,
            "subscriptionEndDate": res.subscriptionEndDate,
            "trialPeriod": res.isTrialPeriod
          });
          this.router.navigate(['/appointments']);
          //this.userFeedback.stopLoading();
        },
        error: () => {
          if (!this.storageService.isAuthenticated()) {
            this.router.navigateByUrl('/auth/login');
          }
        },
      });
    } catch {
      if (!this.storageService.isAuthenticated()) {
        this.router.navigateByUrl('/auth/login');
      }
    }
  }
}
